import React from "react";

export function PageHeader({ eyebrow, title, description, actions, testId }) {
    return (
        <div className="border-b border-border px-8 pt-5 pb-4 flex flex-wrap items-end justify-between gap-x-6 gap-y-3" data-testid={testId || "page-header"}>
            <div className="flex-1 min-w-[260px]">
                {eyebrow && <div className="eyebrow mb-1">{eyebrow}</div>}
                <h1 className="text-2xl md:text-[28px] font-semibold tracking-tight leading-tight">{title}</h1>
                {description && (
                    <p className="text-sm text-muted-foreground mt-1.5">{description}</p>
                )}
            </div>
            {actions && <div className="flex flex-wrap items-center justify-end gap-2">{actions}</div>}
        </div>
    );
}

export function PageContent({ children, className = "" }) {
    return <div className={`px-8 py-4 ${className}`}>{children}</div>;
}
